import { __assign, __read, __spread } from "tslib";
import { Plugin, PluginKey } from 'prosemirror-state';
import { getActiveColor, DEFAULT_COLOR } from '../utils/color';
import { getDisabledState } from '../utils/disabled';
import { textColorPalette, textColorPaletteExperimental, DEFAULT_BORDER_COLOR, } from '../../../ui/ColorPalette/Palettes/textColorPalette';
export { DEFAULT_COLOR } from '../utils/color';
export function createInitialPluginState(editorState, pluginConfig) {
    var defaultColor = (pluginConfig && pluginConfig.defaultColor) || DEFAULT_COLOR;
    var showMoreColorsToggle = (pluginConfig && pluginConfig.EXPERIMENTAL_allowMoreTextColors) || false;
    var palette = __spread([
        {
            value: defaultColor.color,
            label: defaultColor.label,
            border: DEFAULT_BORDER_COLOR,
        }
    ], (showMoreColorsToggle ? textColorPaletteExperimental : textColorPalette));
    var state = {
        color: getActiveColor(editorState),
        disabled: getDisabledState(editorState),
        palette: palette,
        defaultColor: defaultColor.color,
    };
    // break up the palette for A/B testing experiment ED-8368
    if (showMoreColorsToggle) {
        // defined palette order: [normal, dark, light] (but normal[0] is default/dark)
        // expanded palette: [dark, normal, light] with normal[0] on the dark row
        var normalRow = palette.slice(0, 7);
        var darkRow = palette.slice(7, 14);
        var lightRow = palette.slice(14);
        var paletteExpanded = darkRow.concat(normalRow).concat(lightRow);
        // swap default back and slot 7
        var defaultSwatch = paletteExpanded[0];
        paletteExpanded[0] = paletteExpanded[7];
        paletteExpanded[7] = defaultSwatch;
        return __assign(__assign({}, state), { palette: normalRow, paletteExpanded: paletteExpanded });
    }
    return state;
}
export var ACTIONS;
(function (ACTIONS) {
    ACTIONS[ACTIONS["RESET_COLOR"] = 0] = "RESET_COLOR";
    ACTIONS[ACTIONS["SET_COLOR"] = 1] = "SET_COLOR";
    ACTIONS[ACTIONS["DISABLE"] = 2] = "DISABLE";
})(ACTIONS || (ACTIONS = {}));
export var pluginKey = new PluginKey('textColorPlugin');
export function createPlugin(dispatch, pluginConfig) {
    return new Plugin({
        key: pluginKey,
        state: {
            init: function (_config, editorState) {
                return createInitialPluginState(editorState, pluginConfig);
            },
            apply: function (tr, pluginState, _, newState) {
                var meta = tr.getMeta(pluginKey) || {};
                var nextState;
                switch (meta.action) {
                    case ACTIONS.RESET_COLOR:
                        nextState = __assign(__assign({}, pluginState), { color: pluginState.defaultColor });
                        break;
                    case ACTIONS.SET_COLOR:
                        nextState = __assign(__assign({}, pluginState), { color: meta.color, disabled: false });
                        break;
                    case ACTIONS.DISABLE:
                        nextState = __assign(__assign({}, pluginState), { disabled: true });
                        break;
                    default:
                        nextState = __assign(__assign({}, pluginState), { color: getActiveColor(newState), disabled: getDisabledState(newState) });
                }
                if ((pluginState && pluginState.color !== nextState.color) ||
                    (pluginState && pluginState.disabled !== nextState.disabled)) {
                    dispatch(pluginKey, nextState);
                    return nextState;
                }
                return pluginState;
            },
        },
    });
}
//# sourceMappingURL=main.js.map